<button-select
  [disabled]="disabled"
  [model]="relatedItem.linkType"
  [selected]="selectedLink"
  [options]="relationshipOptions"
  [hasOptionCheckIcon]="true"
  [dropdownStyle]="{ width: '150px', height: '259px' }"
  (modelChange)="onUpdateLinkOption($event)">
</button-select>
